import { PACKAGE_LIST_PARAMS_REQUEST } from 'models/package';

export const GET_PACKAGE_LIST_REQUEST: string = 'GET_PACKAGE_LIST_REQUEST';
export const DELETE_PACKAGE_REQUEST: string = 'DELETE_PACKAGE_REQUEST';

export const getPackageListRequest = (
  params?: PACKAGE_LIST_PARAMS_REQUEST | null
) => {
  return {
    type: GET_PACKAGE_LIST_REQUEST,
    payload: { params },
  };
};

export const deletePackageAction = (payload: {
  id: string;
  onSuccess?: () => void;
}) => {
  return {
    type: DELETE_PACKAGE_REQUEST,
    payload,
  };
};
